import { Progress } from "@adora/shadcn-ui";

interface ProgressToastProps {
  message: string;
  progress?: number;
  indeterminate?: boolean;
}

export function ProgressToast({ message, progress, indeterminate = false }: ProgressToastProps) {
  const showPercentage = !indeterminate && progress != null;

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg bg-[#0081EB] px-4 py-3 text-white shadow-lg">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">{message}</span>
        {showPercentage && <span className="text-xs text-white/80">{Math.round(progress)}%</span>}
      </div>
      <Progress value={progress} indeterminate={indeterminate} />
    </div>
  );
}
